import { LoadableLazy } from '@confluence/loadable';
export { isEligibleForProductRequirementsDiscovery } from '../src/rovo/ProductRequirementsDialog';
export const LazyProductRequirementsPublishDiscoveryDialog = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ProductRequirementsDialog" */ '../src/rovo/ProductRequirementsDialog'
			)
		).ProductRequirementsDialog,
});
